import { createSlice } from "@reduxjs/toolkit";
import { getLegalFillDetailsData, getLegalIndividualReferences, getLegalServicePage, legalDocDelete, legalDocUpload } from "./legalServiceActions";
import { getPropertyData, getPropertyOnlyDocsData } from "../property/propertyActions";


const initialState = {
   loading: false,
   references: {
      individuals: [],
      advocates: [],
      corporates: [],
   },
   service: [],
   error: null,
   selectedPropertyId: "",
   fillDetailsData: {},
   selectedPropertyData: {},
   uploadedDocs: []
}

const legalServiceSlice = createSlice({
   name: "legalServiceSlice",
   initialState,
   reducers: {
      setLegalSelectedPropertyId: (state, { payload }) => {
         state.selectedPropertyId = payload
      },
   },
   extraReducers: (builder) => {
      // get legal individual references
      builder.addCase(getLegalIndividualReferences.pending, (state) => {
         state.loading = true
      })
      builder.addCase(getLegalIndividualReferences.fulfilled, (state, { payload }) => {
         state.loading = false
         state.references.individuals = payload.response.data
      })
      builder.addCase(getLegalIndividualReferences.rejected, (state, { payload }) => {
         state.loading = false
         state.error = payload
      })

      // get legal individual service
      builder.addCase(getLegalServicePage.pending, (state) => {
         state.loading = true
      })
      builder.addCase(getLegalServicePage.fulfilled, (state, { payload }) => {
         state.loading = false
         state.service = payload.response.data
      })
      builder.addCase(getLegalServicePage.rejected, (state, { payload }) => {
         state.loading = false
         state.error = payload
      })

      // get legal fill details data
      builder.addCase(getLegalFillDetailsData.pending, (state) => {
         state.loading = true
      })
      builder.addCase(getLegalFillDetailsData.fulfilled, (state, { payload }) => {
         state.loading = false
         state.fillDetailsData = payload.response.data
      })
      builder.addCase(getLegalFillDetailsData.rejected, (state, { payload }) => {
         state.loading = false
         state.error = payload
      })

      // get a single property data
      builder.addCase(getPropertyData.pending, (state) => {
         state.loading = true
      })
      builder.addCase(getPropertyData.fulfilled, (state, { payload }) => {
         state.loading = false
         state.selectedPropertyData = payload?.response?.data?.data?.item
      })
      builder.addCase(getPropertyData.rejected, (state, { payload }) => {
         state.loading = false
         state.error = payload
      })

      // get uploaded property doc data
      builder.addCase(getPropertyOnlyDocsData.pending, (state) => {
         state.loading = true
      })
      builder.addCase(getPropertyOnlyDocsData.fulfilled, (state, { payload }) => {

         state.loading = false
         state.selectedPropertyData = {
            ...state.selectedPropertyData,
            docs: payload?.response?.data?.data?.item?.docs,
            documents: payload?.response?.data?.data?.item?.docs,
            propertyScore: payload?.response?.data?.data?.item?.propertyScore
         }
      })
      builder.addCase(getPropertyOnlyDocsData.rejected, (state, { payload }) => {
         state.loading = false
         state.error = payload
      })

      // legal document upload if not property selected
      builder.addCase(legalDocUpload.pending, (state) => {
         state.loading = true
      })
      builder.addCase(legalDocUpload.fulfilled, (state, { payload }) => {
         state.loading = false
         const newData = payload?.response?.data?.data?.item;
         const obj = { id: newData?.form, url: newData?.url }
         state.uploadedDocs = [...state.uploadedDocs, obj];
      })
      builder.addCase(legalDocUpload.rejected, (state, { payload }) => {
         state.loading = false
         state.error = payload
      })

      // legal document delete document delete
      builder.addCase(legalDocDelete.pending, (state) => {
         state.loading = true
      })
      builder.addCase(legalDocDelete.fulfilled, (state, { payload }) => {
         state.loading = false
         const id = payload?.id
         const presentDocs = state.uploadedDocs
         const updatedDocs = presentDocs.filter(doc => doc?.id !== id);
         state.uploadedDocs = updatedDocs;
      })
      builder.addCase(legalDocDelete.rejected, (state, { payload }) => {
         state.loading = false
         state.error = payload
      })
   }
});

export default legalServiceSlice.reducer;

export const { setLegalSelectedPropertyId } = legalServiceSlice.actions;